function AgentsData() {
    "use strict";

    this.TargetId = -1;
    this.TargetIsMe = false;

    this.IsFirstRun = true;

    this.Clean = null;
    this.Sort = null;
    this.EscalationPlansClean = null;
    this.Dirty = [];
    this.EscalationPlansDirty = null;
    this.Paginated = null;
    this.EscalationPlansPaginated = null;

    // Escalation Plans
    this.EscalationPlanItemList = [];
    this.PlanEditItem = null;

    // Agents
    this.AgentsCurrentId = -1;
    this.UserEditItem = null;
    this.CardViewEditItem = null;
    this.CurrentOrganizations = null;

    // Caseload
    this.AvailableEnrollees = null;
    this.AdditionalEnrollees = null;
    this.ArchivedEnrollees = null;
    this.ArchivedEnrolleesLock = false;
    this.MovingCaseload = false;
    this.SelectedOrganization = -1;
    this.SelectedAgent = -1;

    // Daily Notifications
    this.DailyNotifications = null;

    // Immediate Notifications
    this.ImmediateNotifications = null;

    // Off Hours
    this.OffHours = null;
    this.OffHoursEditItem = null;

    // Notifications
    this.NotificationsCurrentId = -1;

    // Permission
    this.UserPermissions = null;
    this.PermissionsClicked = null;


}
if (typeof exports !== 'undefined') {
    module.exports = AgentsData;
}